<template>
  <div id="app">

    <div :class="['envelope', $store.getters.currentViewState]" @touchstart="dragStart($event)" @mousedown="dragStart($event)" @touchmove="drag($event)" @mousemove="drag($event)" @touchend="dragEnd($event)" @mouseup="dragEnd($event)">
        <!-- MAIN -->
        <section class="main"><router-view></router-view> <!-- No need for name="" because this is the 'default' --></section>
        <!-- SLIDE CONTROL-->
        <section :class="['slider', dragitemClicked ? 'hidehandle' : '']"><div class="sliderhandle" :class="[dragitemClicked ? 'grabbing' : '']"></div><div class="slidershadow" :class="[dragitemClicked ? 'slidershadowOn' : '']"></div></section>
        <!-- SIDE -->
        <section :class="['side', menuOpenedClass]"><router-view name="siderouterview"></router-view></section>
    </div>
    
    <!-- Zoom Modal -->
    <div :class="['zoom-modal', zoomOpenedClass]">
        <div class="zoom-modal-background-close" @click="closeZoom"></div>
        <div class="zoom-modal-content">
            <img :src="'figures/' + $store.getters.zoomFigure" class="zoom-modal-fit" />
        </div>
        <div class="zoom-modal-button-close" @click="closeZoom"></div>
    </div>
    <!-- End of Zoom Modal -->
   
  </div>
</template>

<style>
</style>


<script>
import router from '@/router'

export default {
  name: 'App',
  components: {
  },
  data() { //https://michaelnthiessen.com/vue-props-vs-data/
    return {
        storeddragitemClicked: false,
        storecursorX: null,
        storeddragitemcurrentX: null,
        storeddragiteminitialX: null,
        storeddragitemXoffset: 0  
    }
  },
  computed: {
    zoomOpenedClass: function() {
      if(this.$store.state.zoomOpened){
          return 'show-zoom-modal'
        }else {
            return ''
        }
    },

    menuOpenedClass: function() {
        if(this.$store.state.menuOpened){
          return 'showmenu'
        }else {
            return ''
        }
    },
      dragitemClicked: function(){
        return this.storeddragitemClicked
      },
      cursorX: function(){
        return this.storecursorX
      },
      dragitemcurrentX: function(){
        return this.storeddragitemcurrentX
      },
      dragiteminitialX: function(){
        return this.storeddragiteminitialX
      },
      dragitemXoffset: function(){
        return this.storeddragitemXoffset
      }
  },
  methods: {
      closeZoom: function(){
        this.$store.state.zoomOpened=false;
      },
      dragStart: function(e){
        /* eslint-enable no-console */
        //console.log('dragstart')
        //console.log(e.target)
        /* eslint-disable no-console */
        if (e.type === 'touchstart') {
          this.storeddragiteminitialX = e.touches[0].clientX - this.dragitemXoffset
        } else {
          this.storeddragiteminitialX = e.clientX - this.dragitemXoffset
        }
        //Check if the clicked element is the element we would like to drag
        if (e.target === document.querySelector('.sliderhandle')) {
          this.storeddragitemClicked = true  
        }
      },
      drag: function(e){
        /* eslint-enable no-console */
        //console.log('dragging')
        /* eslint-disable no-console */
        if(this.dragitemClicked){
          e.preventDefault()
          if (e.type === 'touchmove') {
            this.storecursorX = e.touches[0].clientX
            this.storeddragitemcurrentX = e.touches[0].clientX - this.dragiteminitialX
          }else {
            this.storecursorX = e.clientX
            this.storeddragitemcurrentX = e.clientX - this.dragiteminitialX
          }

          this.storeddragitemXoffset = this.dragitemcurrentX

          this.showDragMovt(document.querySelector('.sliderhandle'), document.querySelector('.slidershadow'));
        }
      },
      showDragMovt: function(handle, handleshadow) {
        
        /* eslint-disable no-console */
        //console.log('1 cursorX ' + this.cursorX)
        //console.log('2 initial ' + this.dragiteminitialX)
        //console.log('3 current ' + this.dragitemcurrentX)
        //console.log('4 offset ' + this.dragitemXoffset)
        
        /* eslint-enable no-console */
        var winwidth = window.innerWidth

        
        
        switch(this.$store.state.currentViewState){
            //IF ON HOMEVIEW
            case 'homeview':
            //Record Area
            if(this.cursorX >= winwidth-26){
              handle.style.left = 'calc(100% - 26px)'
            }
            if(this.cursorX >= winwidth-506 && this.cursorX < winwidth-26){
              handle.style.left = 'calc(100% - ' + Math.abs(this.dragitemXoffset) + 'px)'

              //IF OVERSHOOTS the right edge of the window, reset the position of the handle

              handleshadow.style.left= 'calc(100% - ' + Math.abs(this.dragitemXoffset) + 'px)'
              handleshadow.style.width= Math.abs(this.dragitemXoffset) + 'px';
              handleshadow.style.backgroundImage= 'linear-gradient(to right, rgba(255,81,0,.35), rgba(255,81,0,0))'
              
            }
            //About Area
            if(this.cursorX >= 480 && this.cursorX <= winwidth-506){
              handle.style.left = 'calc(100% - ' + Math.abs(this.dragitemXoffset) + 'px)'
              handleshadow.style.left= 'calc(100% - ' + Math.abs(this.dragitemXoffset) + 'px)'
              handleshadow.style.width= Math.abs(this.dragitemXoffset) + 'px';
              
              //SOME STYLING
              handleshadow.style.backgroundImage= 'linear-gradient(to right, rgba(255,81,0,1), rgba(255,81,0,.3))'
            }
            break
            //IF ON RECORDVIEW
            case 'recordview':
            if(this.cursorX < 480){
              handle.style.left = '480px'
              handleshadow.style.left= '506px'
              handleshadow.style.width= 'calc(100% - 986px)'
            
              handle.style.backgroundColor= 'rgba(255,81,0,1)'
            }

            //About Area
            if(this.cursorX >= 480 && this.cursorX <= winwidth-506){
              handle.style.left = 'calc(100% - ' + (506 + Math.abs(this.dragitemXoffset)) + 'px)'
              handleshadow.style.left= 'calc(100% - ' + (506 + Math.abs(this.dragitemXoffset)) + 'px)'
              handleshadow.style.width= Math.abs(this.dragitemXoffset) + 'px';
              
              //SOME STYLING
              handleshadow.style.backgroundImage= 'linear-gradient(to right, rgba(255,81,0,.55), rgba(255,81,0,0))'
            }

            //Home Area
            if(this.cursorX > winwidth-506 && this.cursorX < winwidth-26){

              //Important: Must set the position and width
              handle.style.left = 'calc(100% - ' + (506 - this.dragitemXoffset) + 'px)'
              handleshadow.style.left= 'calc(100% - 506px)'
              handleshadow.style.width= Math.abs(this.dragitemXoffset) + 'px';
              
              handleshadow.style.backgroundImage= 'linear-gradient(to right, rgba(255,81,0,0), rgba(255,81,0,.55))'
            }

            if(this.cursorX >= winwidth-26){
              handle.style.left = (winwidth - 26) + 'px'
              handleshadow.style.left= 'calc(100% - 506px)'
              handleshadow.style.width= '506px'
              
              handleshadow.style.backgroundImage= 'linear-gradient(to right, rgba(255,81,0,.3), rgba(255,81,0,1))'
            }
            break

            //IF ON ABOUTVIEW
            case 'aboutview':
            if(this.cursorX <480){
              handle.style.left = '480px'
              handleshadow.style.left = '480px'
              handleshadow.style.width= '0px'

              
            }

            //Records Area
            if(this.cursorX >= 480 && this.cursorX <= winwidth-506){
              handle.style.left = (480 + this.dragitemXoffset) + 'px'
              handleshadow.style.left= '506px'
              handleshadow.style.width= Math.abs(this.dragitemXoffset) + 'px';
              
              //SOME STYLING
              handleshadow.style.backgroundImage= 'linear-gradient(to right, rgba(255,81,0,0), rgba(255,81,0,.35))'
            }

            //Home Area
            if(this.cursorX > winwidth-506 && this.cursorX < winwidth-26){

              //Important: Must set the position and width
              handle.style.left = (480 + this.dragitemXoffset) + 'px'
              handleshadow.style.left= '506px'
              handleshadow.style.width= Math.abs(this.dragitemXoffset) + 'px';
              
              handleshadow.style.backgroundImage= 'linear-gradient(to right, rgba(255,81,0,.3), rgba(255,81,0,1))'
            }

            if(this.cursorX >= winwidth-26){
              handle.style.left = (winwidth - 26) + 'px'
              handleshadow.style.left= '506px'
              handleshadow.style.width= winwidth-506 + 'px';
              
              handleshadow.style.backgroundImage= 'linear-gradient(to right, rgba(255,81,0,.3), rgba(255,81,0,1))'
            }

        }  
        //End of Switch
        
      },
      dragEnd: function(){
        
          if(this.storeddragitemClicked){
          /* eslint-enable no-console */
          //console.log('dragend')
          /* eslint-disable no-console */
          
          this.storeddragiteminitialX = this.dragitemcurrentX
          this.storeddragitemClicked = false

          var winwidth = window.innerWidth


          //IF ON HOME VIEW
          switch(this.$store.state.currentViewState){
            //IF ON HOMEVIEW
            case 'homeview':
              if(this.cursorX >= winwidth-26){
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)
              }
              //Route to Records
              if(this.cursorX >= winwidth-506 && this.cursorX < winwidth-26){
                router.push(`/records`, () => {}) 
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below

                //delay removing the styles
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)


              }
              //Route to About
              if(this.cursorX <= winwidth-506){
                router.push(`/about`, () => {})
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below
                
                //delay removing the styles
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)

              }
            break

            //IF ON RECORDVIEW
            case 'recordview':

              if(this.cursorX < 480){
                 router.push(`/about`, () => {})
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below
                
                //delay removing the styles
               setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900) 
              }

              //Route to About
              if(this.cursorX >= 480 && this.cursorX <= winwidth-480){
                router.push(`/about`, () => {})
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below
                
                //delay removing the styles
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)
              }

               //Route to Home
              if(this.cursorX > winwidth-506 && this.cursorX < winwidth-26){
                router.push(`/`, () => {}) 
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below

                //delay removing the styles
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)

              }
              if(this.cursorX >= winwidth-26){
                router.push(`/`, () => {}) 
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below

                //delay removing the styles
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)
              }

            break
            
            //IF ON ABOUTVIEW
            case 'aboutview':
              if(this.cursorX <480){
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)
              }
              //Route to Records
              if(this.cursorX >= 506 && this.cursorX < winwidth-506){
                router.push(`/records`, () => {})
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below
                
                //delay removing the styles
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)
              }
              //Route to Home
              if(this.cursorX > winwidth-506 && this.cursorX < winwidth-26){
                router.push(`/`, () => {}) 
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below

                //delay removing the styles
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)

              }
              if(this.cursorX >= winwidth-26){
                router.push(`/`, () => {}) 
                //set to pre-ordained coordinates for sliderhandle and slidershadow via css
                //values are reset below
               
                //delay removing the styles
                setTimeout(()=>{ 
                    this.storecursorX = null
                    this.storeddragitemXoffset = 0
                    this.storeddragitemcurrentX = null
                    this.storeddragiteminitialX = null
                    document.querySelector('.sliderhandle').style= ''
                    document.querySelector('.slidershadow').style=''
                  }, 900)
              }
              
              

              
            }  
          }
        
      }
  //End of Methods
  }
}
</script>